import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { Kullanici } from '../model/kullanici';
import { Page } from '../model/page';
import { Subscription } from 'rxjs';
import { HelperProvider } from '../providers/helper.provider';
import { MenuItem } from '../model/menu-item';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RestService } from '../providers/rest.service';
import { Sube } from '../model/sube';
import { Pair } from 'src/model/pair';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnDestroy {
  user: Kullanici = null;
  year = '';
  name = 'SatinAl-Client';
  website = '';
  version = '1.0.0';
  pageTitleKey = '';
  isLoading = true;
  subscriptions: Subscription[] = [];
  currentPage: Page = null;
  publicMenuItems: MenuItem[] = [];
  adminMenuItems: MenuItem[] = [];
  lojistikMenuItems: MenuItem[] = [];
  allMenuItems: MenuItem[] = [];
  showConnectionError = false;
  isAuthenticated = false;
  subeler: Sube[] = null;
  onaySayisi: Pair[];
  isOnayimdakiler: boolean;

  /**
   * Görülmemiş duyuru sayısını tutar.
   */
  duyuruCount:number;

  constructor(private router: Router,
    private authService: AuthService,
    private helperProvider: HelperProvider,
    private restService: RestService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService) {
  }


  ngOnInit() {
    this.isAuthenticated = this.authService.isLoggedIn();
    this.user = this.authService.getUser();
    this.isOnayimdakiler = this.authService.getIsConfirm();

    const homeMenuIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"></path><polyline points="5 12 3 12 12 3 21 12 19 12"></polyline><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path></svg>`;
    const menuIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"></path><line x1="5" y1="9" x2="19" y2="9"></line><line x1="5" y1="15" x2="19" y2="15"></line><line x1="11" y1="4" x2="7" y2="20"></line><line x1="17" y1="4" x2="13" y2="20"></line></svg>`;

    this.restService.getOnaySayisi(this.user.kullaniciGrupId).subscribe(res => {
      if (res) {
        let onaySayisi = res

        this.publicMenuItems.push(new MenuItem('Ana Sayfa', homeMenuIcon, Page.Anasayfa, 'anasayfa'));
        this.publicMenuItems.push(new MenuItem('Talepler', menuIcon, Page.Talepler, 'talepler', onaySayisi.find(x => x.key == Page.Talepler).value));
        this.publicMenuItems.push(new MenuItem('Teklifler', menuIcon, Page.Teklifler, 'teklifler'));
        this.publicMenuItems.push(new MenuItem('Siparişler', menuIcon, Page.Siparisler, 'siparisler', onaySayisi.find(x => x.key == Page.Siparisler).value));
        this.publicMenuItems.push(new MenuItem('İrsaliyeler', menuIcon, Page.Irsaliyeler, 'irsaliyeler'));
        this.publicMenuItems.push(new MenuItem('Faturalar', menuIcon, Page.Faturalar, 'faturalar', onaySayisi.find(x => x.key == Page.Faturalar).value));

        this.adminMenuItems.push(new MenuItem('Şubeler', '', Page.Subeler, 'subeler'));
        this.adminMenuItems.push(new MenuItem('Kullanıcılar', '', Page.Kullanicilar, 'kullanicilar'));
        this.adminMenuItems.push(new MenuItem('Kullanıcı Grupları', '', Page.KullaniciGruplari, 'kullanici-gruplar'));
        this.adminMenuItems.push(new MenuItem('Talep Türleri', '', Page.TalepTurler, 'talep-turler'));
        this.adminMenuItems.push(new MenuItem('Ürün Grupları', '', Page.UrunGruplar, 'urun-gruplar'));
        this.adminMenuItems.push(new MenuItem('Talep Onay Seviyeler', '', Page.TalepOnayTurleri, 'talep-onay-seviyeler'));
        this.adminMenuItems.push(new MenuItem('Cariler', '', Page.Cariler, 'cariler'));
        this.adminMenuItems.push(new MenuItem('Master', '', Page.Master, 'master-list'));

        this.lojistikMenuItems.push(new MenuItem('Lojistik', menuIcon, Page.Lojistikler, 'lojistik'));
        this.lojistikMenuItems.push(new MenuItem('Arşiv', menuIcon, Page.Lojistikler, 'lojistik-fiyat-arsivler'));
        this.lojistikMenuItems.push(new MenuItem('Kantar', menuIcon, Page.Lojistikler, 'kantar'));

        for (const menuItem of this.publicMenuItems) {
          this.allMenuItems.push(menuItem);
        }
        for (const menuItem of this.adminMenuItems) {
          this.allMenuItems.push(menuItem);
        }
      }
    });

    this.year = new Date().getFullYear().toString();

    this.helperProvider.currentPage$.subscribe(page => {
      let key = '';
      for (const m of this.allMenuItems) {
        if (m.page === page) {
          key = m.name;
          break;
        }
      }
      this.pageTitleKey = key;
      this.currentPage = page;
    });
    this.subscriptions.push(
      this.helperProvider.loading$.subscribe(isLoading => {
        if (isLoading != null) {
          this.isLoading = isLoading;
        }
      }));
    this.subscriptions.push(
      this.helperProvider.showConnectionError$.subscribe(res => {
        if (res) {
          this.showConnectionError = res;
        }
      }));

    this.restService.kullaniciSubeleri().subscribe(res => {
      const selected = this.authService.getSelectedSubeIdList();
      this.subeler = res;
      if (selected != null) {
        for (const sube of this.subeler) {
          if (selected.indexOf(sube.id) !== -1) {
            sube.checked = true;
          }
        }
      }
    });

    this.restService.getAllDuyuru(this.user.id).subscribe(res => {
     var isGorulduList = res.filter(item => !item.duyuruGoruldu.isGoruldu);
     this.duyuruCount = isGorulduList.length;
    });

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  logout() {
    this.authService.logout();
  }

  selectMenu(menuItem: MenuItem) {
    if (menuItem.location) {
      this.router.navigate([menuItem.location]);
    }
  }

  showProfile() {
    const userId = this.user.id;//this.authService.getUser().id;
    this.router.navigate(['kullanici'], { queryParams: { id: userId } });
  }

  getIconSvg(menuItem: MenuItem): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(menuItem.icon);
  }

  get Page() {
    return Page;
  }

  refresh() {
    location.reload();
  }

  selectedBranch(s: Sube) {
    s.checked = !s.checked;

    // hepsi seçili değilse hepsini seç
    if (this.subeler.filter(x => x.checked).length === 0) {
      this.subeler.forEach(x => x.checked = true);
    }

    const selectedIdList = this.subeler.filter(x => x.checked).map(x => x.id);
    // console.log(selectedIdList);
    this.authService.setSelectedSubeIdList(selectedIdList);
    this.helperProvider.changedSelectedBranches$.next(this.subeler);
  }

  setIsConfirm($event: any) {
    debugger;
    this.authService.setIsConfirm($event.target.checked);
    this.helperProvider.isConfirmation$.next($event.target.checked);
  }

  // confirmGosterGizle(): boolean {
  //   let page = this.helperProvider.currentPage$.value;
  //   if (page === Page.Talepler || page === Page.Siparisler || page === Page.Faturalar)
  //     return false;

  //   return true;
  // }

  netsisCariAktar() {
    this.restService.netsisCariAktar(false).subscribe(res => {
      this.toastrService.success("Aktarım Tamamlandı.", "Başarılı!");
    })
  }
}
